import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSort, faSortUp, faSortDown, faEdit, faEye } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import Footer from "../Footer";
import Sidebar from "../sidebar";
import Topnav from "../TopNav";
import { API_URL } from "../config";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { getCurrentDate } from '../Components/DateFunction';
import Swal from 'sweetalert2';
import { ClipLoader } from 'react-spinners';

const CellGroups = () => {
    const [cellGroups, setCellGroups] = useState([]);
    const [filteredMembers, setFilteredMembers] = useState([]);
    const [members, setMmebers] = useState([]);
    const [memberSearchTerm, setMemberSearchTerm] = useState('');
    const [filteredCellGroups, setFilteredCellGroups] = useState([]);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [currentGroupId, setCurrentGroupId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({ Name: '', Description: '', Whatsapp: '', Location: '', LeaderID: '' });
    const [searchTerm, setSearchTerm] = useState('');
    const [sortField, setSortField] = useState('Name');
    const [sortOrder, setSortOrder] = useState('asc');
    const [show, setShow] = useState(false);

    const toggleSidebar = () => {
        setShow(prevShow => !prevShow); // Toggle the show state
    };

    const navigate = useNavigate();

    const fetchCellGroups = async () => {
        try {
            const response = await fetch(`${API_URL}/smallgroups/small-group-leaders`);
            if (!response.ok) throw new Error('Failed to fetch cell groups');
            const data = await response.json();
            setCellGroups(data);
            setFilteredCellGroups(data);
        } catch (error) {
            console.error(error);
            alert('Error fetching cell groups: ' + error.message);
        }
    };

    useEffect(() => {
        fetchCellGroups();
        fetchAllMembers();
    }, []);

    useEffect(() => {
        const filtered = cellGroups.filter(group =>
            (group.Name ? group.Name.toLowerCase() : '').includes(searchTerm.toLowerCase()) ||
            (group.Location ? group.Location.toLowerCase() : '').includes(searchTerm.toLowerCase())
        );
        setFilteredCellGroups(filtered);
    }, [searchTerm, cellGroups]);

    const handleAddGroup = () => {
        setFormData({ Name: '', Description: '', Location: '' });
        setShowAddModal(true);
    };

    const handleEditGroup = (group) => {
        setFormData(group);
        setCurrentGroupId(group.GroupID);
        setShowEditModal(true);
    };

    const handleViewGroup = (cell_id) => {
        navigate(`/cellmembers/${cell_id}`)
    };

    const fetchAllMembers = async () => {
        const response = await fetch(`${API_URL}/members/all/Active`);
        const data = await response.json();
        setFilteredMembers(data);
        setMmebers(data);
    };

    //Modal logic
    useEffect(() => {
        const filtered = members.filter(member =>
            (member.Name || '').toLowerCase().includes(memberSearchTerm.toLowerCase()) ||
            (member.Surname || '').toLowerCase().includes(memberSearchTerm.toLowerCase()) ||
            (member.Email || '').toLowerCase().includes(memberSearchTerm.toLowerCase())
        );
        setFilteredMembers(filtered);
    }, [memberSearchTerm]);

    const handleSubmitAdd = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            // Add the ministry
            const cellResponse = await fetch(`${API_URL}/smallgroups`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });

            // Check if the response is successful
            if (!cellResponse.ok) {
                throw new Error("Failed to create ministry");
            }

            const cellData = await cellResponse.json();
            console.log("API Response:", cellData);

            // Access SmallGroupID from the response object
            if (cellData.SmallGroupID) {
                const leaderResponse = await fetch(`${API_URL}/smallgroupleaders`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        SmallGroupID: cellData.SmallGroupID, // Use the newly created SmallGroupID
                        LeaderID: formData.LeaderID,
                        StartDate: formData.StartDate,
                        EndDate: formData.EndDate
                    }),
                });

                // Check if the leader was added successfully
                if (!leaderResponse.ok) {
                    throw new Error("Failed to add leader to ministry");
                }

                // Alert user on success
                Swal.fire({
                    text: "Cell group added successfully!",
                    icon: "success"
                });

                fetchCellGroups();
                setMemberSearchTerm('');
                setShowAddModal(false);
                setIsLoading(false);
            } else {
                console.error("SmallGroupID not returned from the server");
                Swal.fire({
                    text: "Error, failed to add cell group",
                    icon: "error"
                });
                setIsLoading(false);
            }
        } catch (error) {
            console.error("Error:", error);
            Swal.fire({
                text: "Error, failed to add cell group",
                icon: "error"
            });
            setIsLoading(false);
        }
    };

    const handleSubmitEdit = async (e) => {
        e.preventDefault();
        console.log("Updating group with ID:", currentGroupId);
        console.log("Form Data:", formData); // Log form data

        try {
            const response = await fetch(`${API_URL}/smallgroups/${formData.SmallGroupID}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                const errorText = await response.text(); // Get error text for better debugging
                throw new Error(`Failed to update the cell group: ${errorText}`);
            }

            // Alert user on success
            Swal.fire({
                text: "Cell group updated successfully!",
                icon: "success"
            });

            fetchCellGroups();
            setMemberSearchTerm('');
            setShowEditModal(false);
        } catch (error) {
            console.error(error);
            Swal.fire({
                text: 'Error updating cell group: ' + error.message,
                icon: "error"
            });
        }
    };

    const handleSort = (field) => {
        const order = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
        setSortField(field);
        setSortOrder(order);
        const sortedGroups = [...filteredCellGroups].sort((a, b) => {
            return order === 'asc' ? (a[field] > b[field] ? 1 : -1) : (a[field] < b[field] ? 1 : -1);
        });
        setFilteredCellGroups(sortedGroups);
    };

    const getSortIcon = (field) => {
        if (sortField === field) {
            return sortOrder === 'asc' ? <FontAwesomeIcon icon={faSortUp} /> : <FontAwesomeIcon icon={faSortDown} />;
        }
        return <FontAwesomeIcon icon={faSort} />;
    };

    const generatePDF = () => {
        const doc = new jsPDF();

        doc.setFontSize(20);
        doc.text('New Life Covenant Church', 14, 22);
        doc.setFontSize(15);
        doc.text(`Cell Groups Report ${getCurrentDate()}`, 14, 35);
        doc.setFontSize(12);
        doc.text(`Total Cell Groups: ${filteredCellGroups.length}`, 14, 52);

        autoTable(doc, {
            startY: 62,
            head: [['Zone', 'Address', 'Leader', 'Phone']],
            body: filteredCellGroups.map(cellgrp => [
                cellgrp.Name,
                cellgrp.Location,
                `${cellgrp.LeaderName} ${cellgrp.LeaderSurname}`,
                cellgrp.Phoneno,
            ]),
        });

        doc.save('cellgroups_report.pdf');
    };

    const generateCSV = () => {
        const headers = ['Zone', 'Address', 'Leader', 'Phone'];
        const rows = filteredCellGroups.map(cellgrp => [
            cellgrp.Name,
            cellgrp.Location,
            `${cellgrp.LeaderName} ${cellgrp.LeaderSurname}`,
            cellgrp.Phoneno,
        ]);

        // Create a CSV string
        const csvContent = [
            headers.join(','),
            ...rows.map(e => e.join(','))
        ].join('\n');

        // Create a blob from the CSV string
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        // Create a link element and trigger a download
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', `cellgroups_report_${getCurrentDate()}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div>
            <div className="wrapper">
                <Sidebar show={show} />
                <div className="main-panel">
                    <Topnav toggleSidebar={toggleSidebar} />
                    <div className="container">
                        <div className="page-inner">
                            <div className="d-flex justify-content-between align-items-center pt-2 pb-4">
                                <h2 className="text-capitalize font-weight-bold">
                                    Cell Groups ({filteredCellGroups.length})
                                </h2>
                                <div>
                                    <button className="btn btn-sm" onClick={generateCSV} style={{ backgroundColor: 'rgb(20,24,40)', color: '#ffffff' }}>
                                        <FontAwesomeIcon icon={faPlus} /> Generate CSV
                                    </button> &nbsp;
                                    <button className="btn btn-sm" onClick={generatePDF} style={{ backgroundColor: 'rgb(20,24,40)', color: '#ffffff' }}>
                                        <FontAwesomeIcon icon={faPlus} /> Generate PDF
                                    </button> &nbsp;
                                    <button className="btn btn-sm" onClick={handleAddGroup} style={{ backgroundColor: 'rgb(20,24,40)', color: '#ffffff' }}>
                                        <FontAwesomeIcon icon={faPlus} /> Add Cell Group
                                    </button>
                                </div>
                            </div>

                            <div className="form-group mb-4">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by Zone or Address"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>

                            <div className="table-responsive">
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th onClick={() => handleSort('Name')} style={{ cursor: 'pointer' }}>
                                                Zone {getSortIcon('Name')}
                                            </th>
                                            <th onClick={() => handleSort('Location')} style={{ cursor: 'pointer' }}>
                                                Address {getSortIcon('Location')}
                                            </th>
                                            <th>Leader</th>
                                            <th>Phone</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredCellGroups.map((group) => (
                                            <tr key={group.GroupID}>
                                                <td>{group.Name}</td>
                                                <td>{group.Location}</td>
                                                <td>{group.LeaderName} {group.LeaderSurname}</td>
                                                <td>{group.Phoneno}</td>
                                                <td>
                                                    <button onClick={() => handleEditGroup(group)} className="btn btn-link">
                                                        <FontAwesomeIcon icon={faEdit} />
                                                    </button>
                                                    {/* <button onClick={() => handleDeleteGroup(group.SmallGroupID)} className="btn btn-link">
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button> */}
                                                    <button onClick={() => handleViewGroup(group.SmallGroupID)} className="btn btn-link">
                                                        <FontAwesomeIcon icon={faEye} />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <footer className="footer">
                        <Footer />
                    </footer>
                </div>
            </div>

            {/* Add Cell Group Modal */}
            {showAddModal && (
                <div className="modal fade show" style={{ display: 'block' }} onClick={() => setShowAddModal(false)}>
                    <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content" style={{ boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)', borderRadius: '8px' }}>
                            <div className="modal-header">
                                <h5 className="modal-title">Add Cell Group</h5>
                                <button type="button" className="close" onClick={() => setShowAddModal(false)}>&times;</button>
                            </div>
                            <form onSubmit={handleSubmitAdd}>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <label className="modal-label">Zone</label>
                                        <input type="text" className="form-control" value={formData.Name} onChange={(e) => setFormData({ ...formData, Name: e.target.value })} required />
                                    </div>
                                    <div className="form-group">
                                        <label className="modal-label">Description</label>
                                        <textarea className="form-control" value={formData.Description} onChange={(e) => setFormData({ ...formData, Description: e.target.value })} required />
                                    </div>
                                    <div className="form-group">
                                        <label className="modal-label">Address</label>
                                        <input type="text" className="form-control" value={formData.Location} onChange={(e) => setFormData({ ...formData, Location: e.target.value })} required />
                                    </div>
                                    <div className="form-group">
                                        <label className="modal-label">WhatsApp Link</label>
                                        <input type="text" className="form-control" value={formData.Whatsapp} onChange={(e) => setFormData({ ...formData, Whatsapp: e.target.value })} />
                                    </div>
                                    <div className="form-group">
                                        <label className='modal-label'>Search Leader</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search by Name, Surname, or Email"
                                            style={{ backgroundColor: '#c3f3f580' }}
                                            value={memberSearchTerm}
                                            onChange={(e) => setMemberSearchTerm(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className='modal-label'>Leader</label>
                                        <select
                                            className="form-control"
                                            value={formData.LeaderID}
                                            onChange={(e) => setFormData(prevData => ({ ...prevData, LeaderID: e.target.value }))}
                                            required
                                        >
                                            <option value="">Select Member</option>
                                            {filteredMembers.map(member => (
                                                <option key={member.MemberID} value={member.MemberID}>
                                                    {member.Name} {member.Surname} {member.Email ? `(${member.Email})` : ''}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowAddModal(false)}>Close</button>
                                    {isLoading && (
                                        <div style={{ marginTop: '8px', textAlign: 'center', width: '45px' }}>
                                            <ClipLoader loading={isLoading} size={35} color="blue" />
                                        </div>
                                    )}
                                    {!isLoading && (
                                        <button type="submit" className="btn btn-primary">Add Cell Group</button>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Cell Group Modal */}
            {showEditModal && (
                <div className="modal fade show" style={{ display: 'block' }} onClick={() => setShowEditModal(false)}>
                    <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content" style={{ boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)', borderRadius: '8px' }}>
                            <div className="modal-header">
                                <h5 className="modal-title">Edit Cell Group</h5>
                                <button type="button" className="close" onClick={() => setShowEditModal(false)}>&times;</button>
                            </div>
                            <form onSubmit={handleSubmitEdit}>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <label className="modal-label">Zone</label>
                                        <input type="text" className="form-control" value={formData.Name} onChange={(e) => setFormData({ ...formData, Name: e.target.value })} required />
                                    </div>
                                    <div className="form-group">
                                        <label className="modal-label">Address</label>
                                        <input type="text" className="form-control" value={formData.Location} onChange={(e) => setFormData({ ...formData, Location: e.target.value })} required />
                                    </div>
                                    <div className="form-group">
                                        <label className="modal-label">Description</label>
                                        <textarea className="form-control" value={formData.Description} onChange={(e) => setFormData({ ...formData, Description: e.target.value })} required />
                                    </div>
                                    <div className="form-group">
                                        <label className="modal-label">WhatsApp Link</label>
                                        <input type="text" className="form-control" value={formData.Whatsapp} onChange={(e) => setFormData({ ...formData, Whatsapp: e.target.value })} />
                                    </div>
                                    <div className="form-group">
                                        <label className='modal-label'>Search Leader</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search by Name, Surname, or Email"
                                            style={{ backgroundColor: '#c3f3f580' }}
                                            value={memberSearchTerm}
                                            onChange={(e) => setMemberSearchTerm(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className='modal-label'>Leader</label>
                                        <select
                                            className="form-control"
                                            value={formData.LeaderID}
                                            onChange={(e) => setFormData(prevData => ({ ...prevData, LeaderID: e.target.value }))}
                                            required
                                        >
                                            <option value="">Select Member</option>
                                            {filteredMembers.map(member => (
                                                <option key={member.MemberID} value={member.MemberID}>
                                                    {member.Name} {member.Surname} {member.Email ? `(${member.Email})` : ''}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowEditModal(false)}>Close</button>
                                    <button type="submit" className="btn btn-primary">Update Cell Group</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CellGroups;
